import { useContext, useState } from "react";
import { useDispatch } from "react-redux";
import { addNewTake } from "../../app/slices/TrainingSlice";
import { AssetDetailsDTO } from "../../dto/AssetDTO";

export const useAddNewBubble = () => {
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
  const dispatch = useDispatch();


  const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));

  // const selectImageAsset = async (asset: AssetDetailsDTO) => {
  //   setIsDialogOpen(false);
  //   // add new bubble to training, assetid is id
  //   dispatch(addNewTake({ name: asset.name, assetId: asset.assetId }));

  //   // await delay(200);
  //   // // onboarding on first bubble
  //   // if (!OnboardingService.HasVisited("addFirstBubble")) {
  //   //   console.log("starting add bubble onboarding");
  //   //   setState((prevState) => ({
  //   //     ...prevState,
  //   //     steps: OnboardingService.GetSteps("addFirstBubble"),
  //   //     run: true,
  //   //     onboardingActive: true,
  //   //     context: "addFirstBubble",
  //   //   }));
  //   //   OnboardingService.SetVisited("addFirstBubble");
  //   // } else console.log("not starting add bubble onboarding");
  // };

  const addBubbles = async (assets: AssetDetailsDTO[]) => {
    setIsDialogOpen(false);
    await delay(100);

    for (const asset of assets) {
      dispatch(addNewTake({ name: asset.name, assetId: asset.assetId }));
    }
  };

  return [addBubbles, isDialogOpen, setIsDialogOpen] as const;
};
